import { CheckCircle, DisabledByDefault } from "@mui/icons-material";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";

const DetailProgressPostSidangAdmin = ({ detail }) => {
  if (!detail) return <></>;
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell align="center">Nilai</TableCell>
            <TableCell align="center">Revisi</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {detail.map((status, index) => {
            return (
              <>
                {status.name === "Berkas Akhir" && (
                  <>
                    <TableRow key={index + 1}>
                      <TableCell colSpan={3}></TableCell>
                    </TableRow>
                    <TableRow key={index + 2}>
                      <TableCell colSpan={1}></TableCell>
                      <TableCell colSpan={2} align="center">
                        Telah dikumpul
                      </TableCell>
                    </TableRow>
                  </>
                )}
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                >
                  <TableCell>{status.name}</TableCell>

                  {status.name === "Berkas Akhir" ? (
                    <TableCell colSpan={2} align="center">
                      {status.is_done ? (
                        <CheckCircle className="text-green-500" />
                      ) : (
                        <DisabledByDefault className="text-red-500" />
                      )}
                    </TableCell>
                  ) : (
                    <>
                      <TableCell align="center">
                        {status.nilai ? (
                          <CheckCircle className="text-green-500" />
                        ) : (
                          <DisabledByDefault className="text-red-500" />
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {status.revisi ? (
                          <CheckCircle className="text-green-500" />
                        ) : (
                          <DisabledByDefault className="text-red-500" />
                        )}
                      </TableCell>
                    </>
                  )}
                </TableRow>
              </>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DetailProgressPostSidangAdmin;
